import { useLocation, useNavigate } from 'react-router-dom'
import CustomCardHeader from '../../../components/card/CustomCardHeader'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import CustomCard from '../../../../src/components/card/CustomCard'
import { useDispatch, useSelector } from 'react-redux'
import { getWishlist, setPage } from '../../../redux/slices/wishlistSlice'
import CustomTable, {
  TableCell,
  TableHeader,
  TableRow,
} from '../../../components/table/CustomTable'
import CardBody from '../../../components/card/CardBody'
import ReactPaginate from 'react-paginate'
import Status, { Tag } from '../../../components/table/Status'
import { debounce } from 'lodash'
import { capitalizeFirstLetter } from '../../../helpers/stringHelper'
import CustomTableItemLoader from '../../../components/CustomTableItemLoader'
import NavbarInput from '../../../components/form/NavbarInput'
import LabeledSelect from 'components/selects/LabeledSelect'
import FormLabel from 'components/form/FormLabel'
import Pagination from "components/Pagination";

const WishlistTable = () => {
  const currentPath = '/wish-list'
  const sortOptions = [
    { label: 'Count: Ascending', value: 'ASC' },
    { label: 'Count: Descending', value: 'DESC' },
  ]

  const [selectedOption, setSelectedOption] = useState(sortOptions[1])

  const dispatch = useDispatch()
  const wishlistState = useSelector((state) => state.wishlist)
  const [wishlistItem, setWishlistItem] = useState('')

  const page = wishlistState.page
  const firstRenderUpdate = useRef(true)
  const navigate = useNavigate()
  const location = useLocation()
  const [searchPlaceholder, setSearchPlaceholder] = useState('')

  const handleSortOptionSelect = (selected, reset = false) => {
    if (selected) {
      setSelectedOption(selected)
      getWishlistItems({
        page: reset ? 1 : page,
        item: wishlistItem,
        sort: selected.value
      })
    }
  }
  function dispatchWishlist() {
    const paramData = {
      item: wishlistItem,
      sort: selectedOption.value,
    }
    dispatch(getWishlist(paramData))
  }

  const route = useCallback((page, query = '', selectedOpt) => {
    navigate(
      `${currentPath}?query=${query}&order=${selectedOpt}&page=${page ?? 1}`,
    )
  }, [])

  useEffect(() => {
    if (firstRenderUpdate.current) {
      firstRenderUpdate.current = false

      const urlParam = new URLSearchParams(location.search)
      // const page = urlParam.get('page') ?? 1
      const { pathname } = location
      const page = pathname === currentPath ? urlParam.get('page') ?? 1 : 1
      const wishlistName =
        pathname === currentPath
          ? typeof urlParam.get('query') === 'object'
            ? ''
            : urlParam.get('query')
          : ''
      setWishlistItem(wishlistName)
      setSearchPlaceholder(wishlistName)
      dispatch(setPage(page))
      getWishlistItems({
        page,
        item: wishlistItem,
        sort: selectedOption.value,
      })
    }
  }, [])

  const debouncedSearchWishlistInput = useCallback(
    debounce((e) => {
      setWishlistItem(e.target.value)
      getWishlistItems({
        page: 1,
        item: e.target.value,
        sort: selectedOption.value,
      })
    }, 1000),
    [],
  )

  const onPageClick = (data) => {
    const currentPage = data.selected + 1
    getWishlistItems({
      page: currentPage,
      item: wishlistItem,
      sort: selectedOption.value
    })
  }

  const getWishlistItems = (payload) => {
    dispatch(getWishlist(payload))
    route(payload.page, payload.item, payload.sort)
  }

  return (
    <CustomCard>
      <CustomCardHeader contentPosition="none">
        <div className="w-full flex items-center justify-between">
          <h2 className="text-white text-2xl">Wishlist</h2>
        </div>
      </CustomCardHeader>
      <CardBody>
        <div className="flex items-end justify-between">
          <div className='flex flex-col'>
            <FormLabel label="Sort by" />
            <div className="w-60">
              <LabeledSelect
                options={sortOptions}
                value={selectedOption || ''}
                onChange={(selected) => handleSortOptionSelect(selected, true)}
              />
            </div>
          </div>

          <div className=" mb-5 border border-gray-300 rounded">
            <NavbarInput
              value={searchPlaceholder}
              placeholder="Search wishlist item"
              onChange={(e) => {
                debouncedSearchWishlistInput(e)
                dispatch(setPage(1))
                setSearchPlaceholder(e.target.value)
              }}
            />
          </div>
        </div>

        <CustomTable>
          <thead>
            <TableRow>
              <TableHeader>Product</TableHeader>
              <TableHeader>Manufacturing Company</TableHeader>
              <TableHeader className="text-right">Price</TableHeader>
              <TableHeader className="text-right">Discount</TableHeader>
              <TableHeader>Availability</TableHeader>
              <TableHeader className="text-right">Wishlist Count</TableHeader>
            </TableRow>
          </thead>
          {wishlistState.loading ||
          wishlistState.error.length > 0 ||
          wishlistState.data?.length === 0 ? (
            <CustomTableItemLoader
              loaderItemHeight="h-[48px]"
              loading={wishlistState.loading}
              error={wishlistState.error}
              isEmpty={wishlistState?.data.length === 0}
              count={10}
              colSpan={6}
              retry={dispatchWishlist}
            />
          ) : (
            <tbody>
              {wishlistState.data.map((wishlist, index) => (
                <TableRow key={wishlist?.product_id}>
                  <TableCell className="font-semibold">
                    {wishlist?.label}
                    {(() => {
                      if (wishlist?.has_variants === true) {
                        return (
                          <div className="font-light text-xs">
                            Variant:{' '}
                            {Object.values(wishlist?.variant_values ?? {}).map(
                              (val, index) => (
                                <span key={index}>
                                  {capitalizeFirstLetter(val)}
                                  {index ===
                                  Object.keys(wishlist?.variant_values).length -
                                    1
                                    ? ''
                                    : ', '}
                                </span>
                              ),
                            )}
                          </div>
                        )
                      }
                    })()}
                  </TableCell>
                  <TableCell>
                    {wishlist?.manufacturing_company ? (
                      <Tag label={wishlist?.manufacturing_company} />
                    ) : (
                      'N/A'
                    )}
                  </TableCell>
                  <TableCell className="text-right whitespace-nowrap">
                    NPR. {wishlist?.price}
                  </TableCell>
                  <TableCell className="text-right">
                    {wishlist?.discount ? `${wishlist?.discount}` : 0}%
                  </TableCell>
                  <TableCell>
                    <Status
                      label={wishlist?.disabled ? 'Archived' : wishlist?.sold_out ? 'Out of Stock' : 'In Stock'}
                      isFailure={wishlist?.sold_out || wishlist?.disabled}
                    />
                  </TableCell>
                  <TableCell className="text-right">
                    {wishlist?.count ?? 0}
                  </TableCell>
                </TableRow>
              ))}
            </tbody>
          )}
        </CustomTable>

        {(wishlistState.error.length > 0 || wishlistState.data?.length === 0 || wishlistState.loading) ?
          (<span/>) :
          <Pagination
            pageCount={wishlistState.total_pages}
            onPageChange={onPageClick}
            forcePage={page - 1}
          />}
      </CardBody>
    </CustomCard>
  )
}

export default WishlistTable
